/** Pause symbol indexing briefly after file browser activity so reads are not blocked mid-parse. */
export const BROWSE_INDEX_COOLDOWN_MS = 2_500;

export type FileBrowserActivitySnapshot = {
  inFlightRequests: number;
  inFlightReads: number;
  lastActivityAt: number;
};
